import { defineComponent as _defineComponent } from 'vue'
import { i18n } from '@/i18n';
import EkycBindDialog from '@/components/dialog/ekyc-bind-dialog.vue';
import { goBindCardIndex, jumpPage } from '@tencent/wphk-components-jump-page';
import { EKYC_CHANNELID } from '@/config';
import { ref, onBeforeMount } from 'vue';
import { hasBindCardOrEkyc } from '@/api';
import { to } from '@tencent/wphk-base-utils';
import { biBrow } from '@tencent/fit-bi-sdk';
import { language } from '@tencent/ppd-base-libs';

export default /*#__PURE__*/_defineComponent({
  __name: 'ekyc-notice',
  setup(__props) {

const optionsTitle = i18n('進行跨境消費，需先完成身份認證或綁卡，以免功能及使用額度受限。');
const options = [
  {
    title: i18n('面容認證'),
    logo: require('@/assets/icon/id-card.png'),
    desc: i18n('需掃描香港身份證，完成面容辨識<br />跨境消費年限額：HK$400,000'),
    url: '',
    onClick: () => {
      jumpPage.goCddPage({ adtag: process.env.VUE_APP_PKGNAME, channelId: EKYC_CHANNELID });
    },
    isRecommend: true,
  },
  {
    title: i18n('綁定銀行卡或信用卡'),
    logo: require('@/assets/icon/bank-card.png'),
    desc: i18n('需綁定香港發行的銀行卡或信用卡<br />跨境消費終身限額：HK$25,000'),
    url: '',
    onClick: () => {
      goBindCardIndex(process.env.VUE_APP_PKGNAME);
    },
    isRecommend: false,
  },
];
const isShowNotice = ref(false);
const ekycDialog = ref<InstanceType<typeof EkycBindDialog> | null>(null);

const onClickNotice = () => {
  ekycDialog.value?.onShowDialog();
  biBrow('ekyc_bindcard_tips.notice|ekyc、绑卡小黄条');
};

onBeforeMount(async () => {
  const [err, result] = await to(hasBindCardOrEkyc());
  if (err || !result) return;
  isShowNotice.value = result;
});


return { __sfc: true,optionsTitle, options, isShowNotice, ekycDialog, onClickNotice, EkycBindDialog, language }
}

})